// 국내 종목의 코스피/코스닥 판별 (공용).
// 시트의 market 칸은 대개 "KR"이라 구분이 없어서, 시세 응답(네이버 stockExchangeType)을 1순위로 쓴다.
// 네이버가 실패해 야후 폴백을 탄 경우엔 quote-stream이 심볼 접미사(.KS/.KQ)로 채워 보낸다.

export const isKR = (market) => ["KR", "KS", "KQ"].includes(String(market || "").toUpperCase());

/** 반환: "KS" | "KQ" | null(국내 아님 또는 판별 불가) */
export function krMarketOf(holding, marketData) {
  if (!isKR(holding.market)) return null;
  const live = marketData?.[holding.ticker]?.krMarket;
  if (live === "KS" || live === "KQ") return live;
  const sheet = String(holding.market || "").toUpperCase();   // 시트에 직접 KS/KQ를 적어둔 경우
  if (sheet === "KS" || sheet === "KQ") return sheet;
  return null;
}

export const krMarketLabel = (m) => (m === "KS" ? "코스피" : m === "KQ" ? "코스닥" : null);

// 코스피=남색(보통주 계열), 코스닥=주황. 롱/숏 색(초록·빨강)과 겹치지 않게 고름.
export const krMarketColor = (m) => (m === "KS" ? "#1f3a93" : m === "KQ" ? "#d97706" : "#999");
